module.exports = __webpack_public_path__ + "img/3.2bf35897.png";